export default class PetHeader {
  constructor() {
    this.elm = document.querySelector('[data-role="pet-header"]');
    this.opener = document.querySelector('[data-role="pet-header-sp-content-opener"]');
    this.closer = document.querySelector('[data-role="pet-header-sp-content-closer"]');
    this.nav = document.querySelector('[data-role="pet-header-sp-nav-content"]');
    this.navItems = document.querySelectorAll('[data-role="pet-header-nav-item"]');

    if (!this.elm || !this.opener || !this.closer || !this.nav || !this.navItems.length) return;

    this.opener.addEventListener('click', () => this.openerHandler());
    this.closer.addEventListener('click', () => this.closerhandler());

    this.navItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.close();
      });
    });
  }

  openerHandler() {
    this.open();
  }

  closerhandler() {
    this.close();
  }

  open() {
    this.elm.classList.add('--is-open');
    this.nav.classList.remove('d-none');
    this.opener.classList.add('d-none');
    this.closer.classList.remove('d-none');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.elm.classList.remove('--is-open');
    this.nav.classList.add('d-none');
    this.opener.classList.remove('d-none');
    this.closer.classList.add('d-none');
    document.body.style.overflow = 'auto';
  }
}